import { TournamentStatus } from '@okletsplay/core';
import { TournamentEntity } from 'app/interfaces/entity';
import { currentTournamentSelector } from 'modules/tournaments/store/current-tournament/selectors';
import React, { FC, useMemo } from 'react';
import { useSelector } from 'react-redux';

export const withTournamentStatus =
  <T,>(Component: FC<T>, statuses: TournamentStatus[] = []) =>
  ({ ...props }: T): JSX.Element | null => {
    const entity = (props as unknown as { entity: TournamentEntity })?.entity;
    const currentTournament = useSelector(currentTournamentSelector.tournament);

    const tournament = useMemo(() => entity ?? currentTournament, [entity, currentTournament]);

    const isComponentAvailable = useMemo(
      () => statuses.includes(tournament.status),
      [tournament.status]
    );

    return isComponentAvailable ? <Component {...props} /> : null;
  };
